import { useSyncExternalStore } from 'react';
import { FeatureFlag } from '@core/feature-flags/feature-flag-enums';
import { getFeatureFlag, subscribeToFeatureFlags } from '@core/feature-flags/feature-flags';

export const useFeatureFlag = (flag: FeatureFlag): boolean =>
  useSyncExternalStore(subscribeToFeatureFlags, () => getFeatureFlag(flag));
